import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'likert-question',
    templateUrl: 'likert-question.html',
    styleUrls: ['likert-question.scss'],
  })
export class LikertQuestionComponent {

    @Input()
    public title: string;

    @Input()
    public description: string;

    @Input()
    public value: '1' | '2' | '3' | '4' | '5';

    @Input()
    public valueOnly: boolean = false;

    @Input()
    public minLabel: string;

    @Input()
    public maxLabel: string;

    @Output()
    public valueChange: EventEmitter<string> = new EventEmitter<string>();

    public valueChanged(): void {
      this.valueChange.emit(this.value);
    }

    public hasLabels(): boolean {
      return this.isSet(this.minLabel) || this.isSet(this.maxLabel);
    }

    private isSet(s: string): boolean {
      return s !== undefined && s !== null && s.trim() !== '';
    }

}
